/** Minimum valid backup size in bytes (empty zips are ~22 bytes). */
export const MIN_BACKUP_FILE_SIZE = 100;

/**
 * Triggers a browser download from an axios blob response.
 * @param {import('axios').AxiosResponse<Blob>} response
 * @param {string} fallbackFilename
 */
export function downloadBlobResponse(response, fallbackFilename) {
    const disposition = response.headers['content-disposition'];
    const filenameMatch = disposition?.match(/filename="(.+)"/);
    const filename = filenameMatch?.[1] || fallbackFilename;

    const url = window.URL.createObjectURL(response.data);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.click();
    window.URL.revokeObjectURL(url);
}

/**
 * Extracts an error message from a failed backup download request.
 * @param {unknown} error
 * @returns {Promise<string>}
 */
export async function getBackupDownloadErrorMessage(error) {
    const defaultMessage = 'Failed to download database backup.';

    if (error?.response?.data instanceof Blob) {
        try {
            const text = await error.response.data.text();
            const json = JSON.parse(text);
            return json.error || defaultMessage;
        } catch {
            return defaultMessage;
        }
    }

    return error?.response?.data?.error || defaultMessage;
}
